import { Typography } from "@mui/material";
import { InfoCard } from "@avenue-8/sidekick-ui";
import { RadarGraphic } from "./RadarGraphic";
import {
  CardsRow,
  CardWrap,
  CtaButton,
  Eyebrow,
  Grid,
  Headline,
  Section,
  Subheadline,
  TextColumn,
  TextColumnInner,
  VisualColumn,
} from "./RadarMarketingSection.styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const FEATURE_CARDS = [
  {
    title: "Career moves & milestones",
    description:
      "New roles, promotions, and company news — surfaced automatically from your contacts' public LinkedIn and Instagram activity.",
  },
  {
    title: "A ranked list, not a feed",
    description:
      "Radar ranks who needs your attention next, so you're not scrolling every profile hoping to spot something.",
  },
  {
    title: "A reason to reach out",
    description:
      "Every signal comes with a suggested way to follow up, so starting the conversation is one less thing to figure out.",
  },
];

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const RadarMarketingSection = () => (
  <Section>
    <Grid>
      <TextColumn>
        <TextColumnInner>
          <Eyebrow variant="overline">Life Event Radar</Eyebrow>
          <Headline variant="h3">
            Turn your network into daily revenue opportunities.
          </Headline>
          <Subheadline variant="body1" color="text.secondary">
            Radar monitors public social and professional signals across your
            relationships, then shows you who has a reason to talk, why now, and
            what to say next.
          </Subheadline>
          <CtaButton
            variant="contained"
            onClick={scrollToTop}
            endIcon={<ArrowForwardIcon />}
          >
            Start today
          </CtaButton>
          <CardsRow>
            {FEATURE_CARDS.map((card) => (
              <CardWrap key={card.title}>
                <InfoCard title={card.title}>
                  <Typography variant="body2" color="text.secondary">
                    {card.description}
                  </Typography>
                </InfoCard>
              </CardWrap>
            ))}
          </CardsRow>
        </TextColumnInner>
      </TextColumn>
      <VisualColumn>
        <RadarGraphic />
      </VisualColumn>
    </Grid>
  </Section>
);
